export default __webpack_public_path__ + "static/media/arrow.44d47efe.svg";